import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/oldbull.png")